import {useCallback} from 'react';
import {useAppDispatch} from 'store/hooks';
import type {AdvancedSearchItemsState} from '../types';
import {advancedSearchItemsUpdated} from '../reducer';

export const useSetAdvancedSearchItems = () => {
  const dispatch = useAppDispatch();
  return useCallback(
    (advancedSearchItems: AdvancedSearchItemsState) => {
      dispatch(advancedSearchItemsUpdated(advancedSearchItems));
    },
    [dispatch],
  );
};
